import { Tabs, Tab, SxProps, Stack, Avatar } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { BlueFormIcon, BluePaycheckIcon, FormIcon, PaycheckIcon } from 'Images';
import React from 'react';

interface HeaderTabsProps {
  tabValue: number;
  handleTabChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}

export const HeaderTabs = ({ tabValue, handleTabChange }: HeaderTabsProps) => {
  const dictionary = Dictionary[DICTIONARY.Paychecks];
  const isDesktop = useIsDesktop();

  const tabStyle: SxProps = {
    width: '50%',
    padding: isDesktop ? '16px 0' : '6px 0',
    minHeight: '0px',
    maxWidth: '50%',
    fontSize: isDesktop ? '18px' : '18px',
    color: 'text.primary',
    lineHeight: '24px',
    '&.Mui-selected': {
      fontWeight: '700',
    },
  };

  const isSlip = tabValue === 0;

  return (
    <Stack
      position={isDesktop ? 'static' : 'relative'}
      height={isDesktop ? 'auto ' : '40px'}
    >
      <Stack
        position={isDesktop ? 'static' : 'absolute'}
        width={isDesktop ? 'auto' : '100vw'}
        right={'-24px'}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          sx={{
            width: isDesktop ? 'unset' : '100%',
            minHeight: '0',
            backgroundColor: 'transparent',
            maxWidth: 'unset',
            '& .MuiTabs-flexContainer': {
              borderBottom: (theme) =>
                `2px solid ${theme.palette.primary.shade_200}`,
            },
          }}
          role='tablist'
          aria-labelledby='slips-tablist'
        >
          <Tab
            sx={tabStyle}
            icon={
              <Avatar
                src={isSlip ? BluePaycheckIcon : PaycheckIcon}
                alt=''
                sx={{ width: '24px', height: '24px' }}
              />
            }
            iconPosition='start'
            label={dictionary.paychecks}
            role='tab'
            aria-controls='slips-tablist'
            aria-selected={isSlip}
          />
          <Tab
            sx={tabStyle}
            icon={
              <Avatar
                src={isSlip ? FormIcon : BlueFormIcon}
                alt=''
                sx={{ width: '24px', height: '24px' }}
              />
            }
            iconPosition='start'
            label={dictionary.tofes106}
            role='tab'
            aria-controls='slips-tablist'
            aria-selected={!isSlip}
          />
        </Tabs>
      </Stack>
    </Stack>
  );
};
